// --------- constant --------------//
export const SELECT_DEFAULT = { value: "", label: "" };
export const ITEMS_PER_PAGE = 12;
// export const WHATS_APP_NUMBER = "+251956551617";
export const ETHIOPIAN_PHONE_NUMBER_REGEX = /^9[0-9]{8}$/;
export const ALPHABETS_REGEX = /^[a-zA-Z ]*$/;
export const OTP_REGEX = /^\d{6}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const showProductStatusPages = ["/products-list", "/approval-request"];
export const categoriesPaging = {
  paging: {
    pageSize: 1000,
    start: 0,
  },
};

// --------- ENUM --------------//
export enum USER_TYPE {
  SELLER = "SELLER",
  BUYER = "BUYER",
  PROVIDER = "PROVIDER",
}
export enum NOTIFICATION_TYPE {
  MY_MARKET_MESSAGE = "MY_MARKET_MESSAGE",
  ADVERTISEMENT_APPROVEMENT = "ADVERTISEMENT_APPROVEMENT",
}
export const CLEAR_PRODUCT_DETAILS_RIGHTS = [
  "preview",
  "add-new-product",
  "edit-product",
  "preview",
];

export enum PRODUCT_STATUS {
  APPROVED="APPROVED",
  REJECTED="REJECTED",
  PENDING="PENDING",
}

export enum SORTING_TYPE {
  POSTED_DATE="POSTED_DATE",
  MOST_POPULAR="MOST_POPULAR",
}
export enum UPLOAD_FILE_TYPES {
  IMAGE="IMAGE", 
  FILE="FILE", 
  VOICE="VOICE",
}

export enum DELETE_IMAGE_ACTION_TYPES {
  PRODUCT_IMAGES="PRODUCT_IMAGES",
  UPLOADED_IMAGES="UPLOADED_IMAGES",
}

export const LANGUAGES = {
  ENGLISH:{label:"English", value: "en"},
  AMHARIC:{label:"Amharic", value: "am"},
  OROMO:{label:"Oromo", value: "om"},
}

export const CURRENCY = {
  ETB:"ETB",
}

export const SOCIAL_MEDIA_LINK = {
  TWITTER: `https://twitter.com/atobaba24`,
  INSTAGRAM: `https://www.instagram.com/ato.baba24/`,
  FACEBOOK: `https://www.facebook.com/profile.php?id=61555552115500`,
}

export const SP_UPDATE_MODAL_STEPS = {
  INCREMENT: "INCREMENT",
  DECREMENT: "DECREMENT",
}

export enum CHAT_CHANNEL {
  BUYER_SELLER="BUYER-SELLER",
  BUYER_PROVIDER="BUYER-PROVIDER"
}

export enum SEND_MESSAGE_EVENT {
  BUYER_SELLER="sendMessage",
  BUYER_PROVIDER="sendOrdinaryMessage"
}